module.exports = __webpack_public_path__ + "img/business_in_transition_color.94b48b23.svg";